import {FC} from 'react';
import {useFormContext} from 'react-hook-form';

const QuestionDescription: FC = () => {
  const {register} = useFormContext();

  return (
    <label htmlFor="description">
      <div className="flex justify-between">
        <p className="mb-[10px] text-base text-black font-medium">Формулировка вопроса</p>
        <span className="text-red text-base font-bold">*</span>
      </div>

      <input {...register('Description', {required: true})} id="Description" type="text" className="w-full rounded-md shadow-custom mb-5 border-[#DFE4EA]" placeholder="Введите формулировку вопроса" />
    </label>
  );
};

export default QuestionDescription;
